import {
  useAdminGetExamCenterProctorByIdQuery,
  type GetExamCenterProctorByIdOutput,
} from '@exam-center/graphql';
import { Navigate } from '@exam-center/router';
import { Loading } from '@shared/components';
import { type PropsWithOptionalChildren } from '@shared/utils';
import { createContext, useMemo } from 'react';

export type Proctor = GetExamCenterProctorByIdOutput['examCenterProctor'];

interface AdminProctorDetailsContextValue {
  proctor: Proctor;
}

interface AdminProctorDetailsProviderProps extends PropsWithOptionalChildren {
  proctorId: string;
}

export const AdminProctorDetailsContext = createContext<
  AdminProctorDetailsContextValue | undefined
>(undefined);

export default function AdminProctorDetailsProvider(
  props: Readonly<AdminProctorDetailsProviderProps>,
) {
  const { proctorId, children } = props;

  const { data: getProctorData, loading: isUseGetExamCenterProctorLoading } =
    useAdminGetExamCenterProctorByIdQuery({
      variables: { getExamCenterProctorByIdInput: { examCenterProctorId: proctorId } },
    });

  const proctor = getProctorData?.ecAdminGetExamCenterProctorById?.examCenterProctor;

  const contextValue: AdminProctorDetailsContextValue = useMemo(() => {
    return {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      proctor: proctor!,
    } as AdminProctorDetailsContextValue;
  }, [proctor]);

  if (isUseGetExamCenterProctorLoading) {
    return <Loading sx={{ height: '100dvh' }} />;
  }

  if (!proctor) {
    return <Navigate to='/admin/exam-proctors/proctors' />;
  }
  return (
    <AdminProctorDetailsContext.Provider value={contextValue}>
      {children}
    </AdminProctorDetailsContext.Provider>
  );
}
